<template>
	<div class="flex xs-12 xs-left">
		<div class="width-smaller pr1">
			<j-base-select
				:options="clientTypeOptions"
				:value="clientType"
				:allowSelectNothing="false"
				@input="onClientTypeChange($event)"
			/>
		</div>
		<div class="width-larger">
			<j-base-multi-select-with-flexible-value
				:id="id"
				:options="options"
				:value="value"
				:placeholder="$t('search_clients')"
				:allowMultiselect="allowMultiselect"
				:allowLocalSearch="false"
				:status="status"
				:isLoading="isLoading"
				valueKey="id"
				nameKey="name"
				@focus="onSearch"
        @blur="onBlur"
				@input="onInput($event)"
				@search="onSearch($event)"
			/>
		</div>
	</div>
</template>

<script>
import JBaseSelect from "@/components/JBaseSelect/"
import JBaseMultiSelectWithFlexibleValue from "@/components/JBaseMultiSelectWithFlexibleValue"
import api from "../api/"
import debounce from "lodash.debounce"

export default {
	components: { JBaseMultiSelectWithFlexibleValue, JBaseSelect },
	props: {
		value: {
			validator(value) {
				return value === null || value instanceof Array
			},
			required: true,
			default: () => []
		},
		id: {
			type: String,
			required: false
		},
		status: {
			type: String,
			required: false
		},
		clientType: {
			type: String,
			required: false,
			default: "individual" // or company
		},
		allowMultiselect: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			clientTypeOptions: [
				{ name: this.$t("individual"), value: "individual" },
				{ name: this.$t("company"), value: "company" }
			],

			options: [],
			isLoading: false
		}
	},

	computed: {
		justCreatedClient() {
			return this.$store.state.clients?.creating?.lastCreatedItem
		}
	},

	methods: {
		onInput(value) {
			this.$emit("input", value)
    },
    
    onBlur() {
      this.options = []
    },
    

    /**
     * Behaviour: 
     * If not searching, show 100 most recently created clients (not alphabetically sorted)
     * if searching for specific client, sort results alphabetically
     */
		onSearch: debounce( async function (searchTerm = null) {
			this.isLoading = true

			let apiKeys = {
				request: "individuals",
				result: "individuals"
      }
      
			if (this.clientType === "company")
				apiKeys = { request: "companies", result: "companies" }

			const where = searchTerm
				? { name_contains: searchTerm, type_in: "CUSTOMER" }
        : { type_in: "CUSTOMER" }

      const sort = !searchTerm ? {fieldName: "createdAt", type: "desc" } : null

      const limit = !searchTerm ? 100 : null

			let res = await api[apiKeys.request]({ where, sort, limit })

			if (!res.errors) {
        this.options = !searchTerm 
          ? res.data[apiKeys.result].list 
          : res.data[apiKeys.result].list
            .sort((a, b) => {
              let nameA = a.name.toUpperCase()
              let nameB = b.name.toUpperCase()

              if (nameA < nameB) return -1
              if (nameA > nameB) return 1

              return 0
            })
      }
      
      this.isLoading = false
    }, 500),

		async onAfterClientCreation() {
			if (this.justCreatedClient.key !== "CUSTOMER") return // watch only if CUSOTMER created (not interested in INSURED or BENEFICIARY)

			this.isLoading = true

			let apiKeys = {
				request: "individuals",
				result: "individuals"
			}
			if (this.clientType === "company")
				apiKeys = { request: "companies", result: "companies" }

			let res = await api[apiKeys.request]({
				where: { id: this.justCreatedClient.id }
			})

			if (!res.errors) {
				this.options = res.data[apiKeys.result].list
				this.$emit("input", res.data[apiKeys.result].list)
			}

			this.isLoading = false
		},

		onClientTypeChange(value) {
			// resets
			this.$emit("input", [])
			this.options = []

			// Emit clientTypeChange event
			this.$emit("clientTypeChange", value)
		}
	},

	watch: {
		// When client is created, it will trigger action here
		justCreatedClient: {
			handler() {
				this.onAfterClientCreation()
			},
			immediate: false,
			deep: true
		}
	}
}
</script>
<style scoped>
.width-smaller {
	width: 40%;
	/* min-width: 180px; */
}
.width-larger {
	width: 60%;
}
</style>
